
export const sFechaPublicacion = '2026-03-20T16:11:42.9610795-06:00';
export const sVersion = 'vf1.1.603201611';
            